import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import usePWAStatus from '../hooks/usePWAStatus';

const { FiRefreshCw } = FiIcons;

const UpdateNotice = () => {
  const { updateAvailable, updateServiceWorker } = usePWAStatus();

  if (!updateAvailable) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-blue-600 text-white rounded-lg shadow-lg p-4 z-50"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <SafeIcon icon={FiRefreshCw} className="w-5 h-5 mr-2" />
          <span className="font-medium">Update available!</span>
        </div>
        <button
          onClick={updateServiceWorker}
          className="ml-4 px-3 py-1 bg-white text-blue-600 rounded-md text-sm font-medium hover:bg-blue-50 transition-colors"
        >
          Refresh
        </button>
      </div>
    </motion.div>
  );
};

export default UpdateNotice;